import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

import { post } from '_utils/xhr';

import APITokenForm from '_forms/apiToken';
import CreateModalWrapper from '_forms/createModal';

const initialValues = { name: '' };

const AddAPITokenModal = ({ onCreate }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [token, setToken] = useState(null);
  const [values, setValues] = useState(initialValues);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  const onDismiss = () => {};

  const onChange = (e, data) => setValues({ [data.name]: data.value });
  const onCancel = () => setValues(initialValues);
  const onSubmit = (e) => {
    e.preventDefault()
    post('/apitokens', values)
      .then(body => {
        if (onCreate) onCreate(body);
        setToken(body);
      })
      .catch(err => window.alert(err.message))
  };

  const onCopy = (jwt) => {
    navigator.clipboard.writeText(jwt).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <CreateModalWrapper
      onOpen={ onOpen }
      onClose={ onClose }
      onDismiss={ onDismiss }
      open={ isOpen }

      header='Create an API Token'
      type='api token'
      iconName='plus'
      iconHeader='Add API Token'
    >
      {
        token ? (
          <Fragment>
            <p>
              Please copy the Token shown below. Due to security reason it cannot be shown again and will have to be regenerated.
            </p>
            <Input
              action={{
                labelPosition: 'right',
                icon: 'copy',
                color: 'blue',
                content: copied ? 'Copied!' : 'Copy',
                onClick: () => onCopy(token.jwt)
              }}
              value={ token.jwt }
              fluid
              readOnly
            />
          </Fragment>
        ) : (
          <APITokenForm
            values={ values }
            dirty={ !!values.name.length }
            onSubmit={ onSubmit }
            onChange={ onChange }
            onCancel={ onCancel }
          />
        )
      }
    </CreateModalWrapper>
  );
};

AddAPITokenModal.propTypes = {
  onCreate: PropTypes.func.isRequired
}

export default AddAPITokenModal;



// WEBPACK FOOTER //
// ./webAdmin/components/apitokens/addToken.js